import React, { Component } from 'react'

import OtpInput from '../lib';
import axios from 'axios';
import { browserHistory } from 'react-router-dom'

class OTPVerify extends Component {

  constructor(props) {
    super(props);
    this.state = {
      timer: 10,
      minutes: '9',
      seconds: 59,
      showTimer: true,
      requestID: '',
      inputValue: '',
      invalidOTP: '',
      disabled: 'disabled',

      clientID: '',
      payeeEmail: '',
      payeeName: '',
      entityName: '',
      requestID: ''  
    }
  }

  componentDidMount() {
    //alert(this.props.location.state.requestID);
    this.setState({ requestID: this.props.location.state.requestID });
    this.setState({ clientID: this.props.location.state.clientID });
    this.setState({ payeeEmail: this.props.location.state.payeeEmail });
    this.setState({ payeeName: this.props.location.state.payeeName });
    this.setState({ entityName: this.props.location.state.entityName });
    
    //alert(localStorage.getItem('payeeName'));
    this.clockCall = setInterval(() => {
      this.decrementClock();
    }, 1000)
  }

  componentWillUnmount() {
    clearInterval(this.clockCall)
  }

  decrementClock = () => {
    if (this.state.seconds === 0) {
      this.setState((prevstate) => ({ minutes: prevstate.minutes - 1, seconds: 60 }))
    }
    this.setState((prevstate) => ({ seconds: prevstate.seconds - 1 }));

  }

  verifyOTP() {   

    debugger;

   const AuthStr = 'A-Token '.concat(this.state.requestID); 
   const authAxios = axios.create({  
    baseURL: axios.defaults.authURL,
    headers: {         
        'Authorization': AuthStr
    },
   });
   // Authentication using Auth Code - AON End

    // const URL = axios.defaults.baseURL + '/PayeePortal/VerifyOTP?requestID=' + this.state.requestID + '&otp=' + this.state.inputValue
  //  axios.get(URL)

    const URL='Token/AuthenticateAuthCode?MFACode='+this.state.inputValue+'&sendotp=false'  
    authAxios.post(URL)    
      .then(response => {
        debugger;
        if (response.data.coreRes.userMessage == "InvalidOTP" ) {  
          this.setState({ invalidOTP: "OTP entered is invalid!" });       
                  
        } 
        else if (response.data.coreRes.userMessage == "Lock request,due to incorrect OTP tried, max limit exceed.Please contact Ascendant representative" )
        {
            this.setState({ invalidOTP: "Max OTP Limit is reached. Please click on link again!" });   
            this.props.history.push('/Lock');
        }
        else if (response.data.coreRes.userMessage == "Expired Token -001" )
        {
              this.setState({ invalidOTP: "Expired Token -001" });   
              this.props.history.push('/Expiredlink');
        }
        else {
          let path = `/Dashboard`;
          if(response.data.TokenName !=undefined && response.data.TokenName=="token"){
            this.props.history.push(path, {
              requestID: response.data.TokenValue,
              payeeName: this.state.payeeName,
              entityName: this.state.entityName,
              clientID: this.state.clientID,
              payeeEmail: this.state.payeeEmail
            });
          }  
        }

      }).catch(function (error) {
        console.log(error);
      })


  }


  ResendOTP() {    
    debugger;
    const AuthStr = 'A-Token '.concat(this.state.requestID); 
   const authAxios = axios.create({  
    baseURL: axios.defaults.authURL,
    headers: {         
        'Authorization': AuthStr
    },
   });

   const URL='Token/AuthenticateAuthCode?MFACode=&sendotp=true'  
   authAxios.post(URL) 
   window.location.reload(false);
  }

  render() {
    let { minutes,inputValue } = this.state   

    if (minutes === -1) {
      this.setState({ showTimer: !this.state.showTimer })
      this.setState({ minutes: "OTP has been expired" })
    }

    if (inputValue.length==6) {      
      document.getElementById("verifyOTPID").focus();
      document.getElementById("verifyOTPID").style.borderColor="white";
      document.getElementById("verifyOTPID").style.backgroundColor="#0277B3";
    }

    return (
      <div>

        {this.state.showTimer ?

          <div>
            <section id="wrapper">
              <div class="login-register" style={{ backgroundImage: "url(assets/images/back_AFX.png)" }}>
                <div class="lgtop"><img src="assets/images/afxlogo.png" /></div>
                <div class="login-box card">
                  <div class="card-body" style={{ padding: "0.5rem" }}>
                    <div style={{ fontSize: "14px", color: "#fff" }}>
                      <b>Welcome {this.state.payeeName},</b>
                      <br />
                      <br />
                      <p>A one time verification password has been to sent to your registered email id. Please enter it below to proceed.</p>
                      <div class="otp-box">OTP expires in <span id="timer" style={{ color: "red" }}> {this.state.minutes + ":" + this.state.seconds} Seconds</span></div>

                      <OtpInput
                        inputStyle={{
                          width: '3rem',
                          height: '3rem',
                          margin: '0 .65rem',
                          fontSize: '2rem',
                          borderRadius: 4,
                          border: '1px solid rgba(0,0,0,0.3)',
                        }}
                        numInputs={6}
                        shouldAutoFocus
                        // onChange={otp => this.setState({inputValue:otp}),this.test()}
                        onChange={otp => this.setState({ inputValue: otp })}
                      //value={this.state.inputValue}
                      />
                    </div>
                  </div>

                  <div class="form-group text-center m-t-30">
                    <div class="row">
                      <div class="col-md-6">
                        <span style={{ fontWeight: "bold", fontSize: "18px", color: "red" }} > {this.state.invalidOTP}</span>
                      </div>
                      <div class="col-md-6">
                        <button class="btn btn-logs btn-lg btn-primary waves-effect waves-light pull-right" id="verifyOTPID" style={{ cursor: "pointer" }} onClick={() => { this.verifyOTP() }}>Verify</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          :
          <div>
            <section id="wrapper">
              <div class="login-register" style={{ backgroundImage: "url(assets/images/back_AFX.png)" }}>
                <div class="lgtop"><img src="assets/images/afxlogo.png" /></div>
                <div class="login-box card">
                  <div class="card-body" style={{ padding: "0.5rem" }}>
                    <div style={{ fontSize: "14px", color: "#fff" }}>
                      <b>Welcome {localStorage.getItem('payeeName')},</b>
                      <br />
                      <br />
                      <p>A one time verification password has been to sent to your registered email id. Please enter it below to proceed.</p>

                      <div style={{ color: "red", fontSize: "18px" }}>OTP has been expired.</div>

                    </div>
                  </div>

                  <div class="form-group text-center m-t-30">
                    <div class="col-md-12 offset-md-4">
                      <button type="submit" class="btn btn-lg btn-light waves-effect waves-light mr-2" style={{ cursor: "pointer" }} onClick={() => { this.ResendOTP() }}>Resend OTP</button>

                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        }
      </div>
    )
  }
}
export default OTPVerify
